import React, { useEffect, useState } from "react";
import { string, array, func, object, number } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";
import throttle from "lodash/throttle";

import TheQuintLogo from "../../atoms/icons/the-quint-logo";
import HindiQuintLogo from "../../atoms/icons/hindi-quint-logo";
import BQLogo from "../../atoms/icons/bq-logo";
import FitColorLogo from "../../atoms/icons/fit-color-logo";
import QuintHindiLogo from "../../atoms/icons/quint-hindi-logo";
import FitLogo from "../../atoms/icons/fit-logo";
import SearchIcon from "../../atoms/icons/search-icon";
import HamburgerIcon from "../../atoms/icons/hamburger-icon";
import ToggleTheme from "../../atoms/toggle-theme";
import Button from "../../atoms/button";
import LinkView from "../../atoms/link-view";
import SecondaryMenu from "../../molecules/secondary-menu";
import MobilePopupMenu from "../../molecules/mobile-popup-menu";
import LoginView from "../login-view";
import PopupModal from "../../atoms/popup-modal";
import SettingsView from "../../molecules/settings-view";
import ProfileImage from "../../atoms/profile-image";

import { getUser } from "../../helper/api";
import { setMember, setUserPlans, setAccessTypeLoad } from "../../helper/actions";
import { getCollectionSlug, getUserMetaData } from "../../utils/utils";
import translate from "../../translate";
import {
  getMyPlans,
  setAccessTypeUser,
  getAccessTypeUrl,
  loadAccessType,
  buyZeroValuePlan,
} from "../../helper/access-type";
import { readCookie, eraseCookie } from "../../helper/cookies";

import "./header.m.css";

const Header = ({
  secondaryMenuItems,
  hamburgerMenuItems,
  pageType,
  currentPath,
  sectionsList,
  menuList,
  sectionId,
  collectionItems,
  publisherAttributes,
  member,
  setUserPlans,
  setMember,
  navigateToPage,
  setAccessTypeLoad,
  currentHostUrl,
}) => {
  const [isNavBarOpen, setIsNavBarOpen] = useState(false);
  const [isLoginPopupViewOpen, setIsLoginPopupViewOpen] = useState(false);
  const [isSettingsPopupViewOpen, setIsSettingsPopupViewOpen] = useState(false);
  const [menuItems, setMenuItems] = useState(null);
  const [isHomeMenuRequired, setIsHomeMenuRequired] = useState(true);

  let prevScrollpos = null;
  const publisherName = publisherAttributes.name;

  useEffect(() => {
    if (publisherName === "quint" && global.AccessType) {
      setUpUserFlow();
    } else if (publisherName === "quint") {
      const env = publisherAttributes.env || "production";
      const accountKey = publisherAttributes.accesstype.account_key;
      const url = getAccessTypeUrl(accountKey, env);
      loadAccessType(url, setUpUserFlow);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", throttle(handleScroll, 50));
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (pageType === "big-story-section-page") {
      customNavBarSections("big-story");
      return;
    }

    if (pageType === "section-page" && sectionId) {
      // Check if its a section page ex: /news but not /news/something or /collection/something
      if (currentPath.split("/").length - 1 === 1) {
        const path = currentPath.charAt(0) === "/" ? currentPath.substr(1) : currentPath;
        let newList = null;

        // For videos pull from the specific video section
        if (path === "videos") {
          customNavBarSections(path);
          return;
        }

        const menuObj = menuList.find((c) => c["menu-group-slug"] === "Sections" && c["item-id"] === sectionId);

        // First check in the menus to find the children of it
        if (menuObj) {
          newList = menuList.filter((c) => c["parent-id"] === menuObj.id);

          if (newList.length) {
            setMenuItems(newList);
            setIsHomeMenuRequired(false);
            return;
          }
        }

        if (!(newList && newList.length)) {
          // Search for all sub-sections in section
          newList = sectionsList
            .filter((c) => c["parent-id"] === sectionId)
            .map((c) => ({
              title: c["display-name"] || c.name,
              completeUrl: `${currentPath}\\${c.slug}`,
              isExternalLink: false,
            }));

          if (newList.length) {
            setMenuItems(newList);
            setIsHomeMenuRequired(false);
            return;
          }
        }
      }
    }

    setMenuItems(secondaryMenuItems);
    !isHomeMenuRequired && setIsHomeMenuRequired(true);
  }, [pageType, sectionId]);

  const handleScroll = () => {
    var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollPos > prevScrollpos) {
      document.getElementById("header").classList.add("moveContentUp");
    } else {
      document.getElementById("header").classList.remove("moveContentUp");
    }

    prevScrollpos = currentScrollPos <= 0 ? 0 : currentScrollPos;
  };

  const customNavBarSections = (path) => {
    let newList = null;

    if (path === "videos") {
      newList = collectionItems
        .filter((c) => c.type === "collection")
        .map((c) => ({ title: c.name, completeUrl: getCollectionSlug(c, sectionsList), isExternalLink: false }));
    } else {
      newList = collectionItems
        .filter((c) => c.type === "collection")
        .map((c) => ({ title: c.name, completeUrl: `${path}\\${c.slug}`, isExternalLink: false }));
    }

    if (newList.length) {
      setMenuItems(newList);
      setIsHomeMenuRequired(false);
    }
  };

  const setUpUserFlow = () => {
    setAccessTypeLoad();
    getUser()
      .then((res) => {
        const userInfo = res.member;
        setMember(userInfo);
        const metadata = getUserMetaData(userInfo);
        setAccessTypeUser(userInfo.email, metadata.mobileNumber);
        getMyPlans().then((plans) => {
          setUserPlans(plans);
          handlePaytmPayment();
        });
      })
      .catch((ex) => console.log(ex.message));
  };

  const handlePaytmPayment = () => {
    if (readCookie("paytmTxn") === "success") {
      const paytmId = readCookie("paytmId");
      if (paytmId) {
        buyZeroValuePlan(paytmId)
          .then(() => {
            eraseCookie("paytmId");
            eraseCookie("paytmTxn");
          })
          .catch((e) => console.log("error", e));
      }
    }
  };

  const onHamburgerClick = () => {
    if (isNavBarOpen) {
      setIsNavBarOpen(false);
      document.getElementById("mySidenav").style.left = "-100%";
      document.body.style.overflowY = "auto";
    } else {
      setIsNavBarOpen(true);
      document.getElementById("mySidenav").style.left = "0";
      document.body.style.overflowY = "hidden";
    }
  };

  const onPopupLoginClick = () => setIsLoginPopupViewOpen(!isLoginPopupViewOpen);

  const onLoginClick = () => {
    window.dataLayer.push({
      event: "login_try",
      login_initiate_page: currentPath || "/",
      login_initiate_position: "ATF - Header",
    });

    setIsLoginPopupViewOpen(true);
  };

  const onPopupSettingsClick = () => {
    setIsSettingsPopupViewOpen(!isSettingsPopupViewOpen);

    isNavBarOpen && onHamburgerClick();
  };

  // Show the Login or Settings View depending whether user is logged in
  const loginView = () => {
    if (member) {
      return <ProfileImage member={member} onClick={onPopupSettingsClick} />;
    }

    return <Button content={translate(publisherName, "login")} buttonType="type1" onClick={onLoginClick} />;
  };

  const getButtonsView = () => {
    // Fit and Hindi doesn't have support, subscribe, login view
    if (publisherName !== "quint") {
      return null;
    }

    const handleClick = () => {
      window.localStorage.setItem("sym_initiate_page", currentPath || "/");
      window.localStorage.setItem("sym_initiate_position", "ATF - Header");
    };

    const getPlanSelectionUrlWithUtms = () => {
      let planSelectionUrl = `/plan-selection`;

      if (publisherName !== "quint") {
        planSelectionUrl += `?utm_source=desktop_top&utm_medium=Internal_${
          publisherName === "fit" ? "FIT" : "HQ"
        }&utm_campaign=WebHooks`;
      }
      return planSelectionUrl;
    };

    return (
      <React.Fragment>
        <Link
          href={getPlanSelectionUrlWithUtms()}
          styleName="support-subscribe-btn"
          className="header-support-the-quint"
        >
          <div styleName="subscribe-btn" onClick={handleClick}>
            {translate(publisherName, "subscribe")}
          </div>
          <div styleName="support-quint" onClick={handleClick}>
            {translate(publisherName, "support_the_quint")}
          </div>
        </Link>
        {loginView()}
      </React.Fragment>
    );
  };

  // Login Popup Modal View
  const loginPopupView = () => {
    if (!isLoginPopupViewOpen) {
      return null;
    }

    return (
      <PopupModal closePopup={onPopupLoginClick}>
        <LoginView closePopup={onPopupLoginClick} setUpUserFlow={setUpUserFlow} />
      </PopupModal>
    );
  };

  // Settings Popup Modal View
  const settingsPopupView = () => {
    if (!isSettingsPopupViewOpen) {
      return null;
    }

    return (
      <PopupModal closePopup={onPopupSettingsClick}>
        <SettingsView closePopup={onPopupSettingsClick} navigateToPage={navigateToPage} />
      </PopupModal>
    );
  };

  // Logs for English Quint
  const getQuintLogoView = () => (
    <React.Fragment>
      <div styleName="vertical-line"></div>

      <LinkView className="header-hq-logo opacity-logo" link="https://hindi.thequint.com/">
        <QuintHindiLogo />
      </LinkView>

      <LinkView className="header-bq-logo bq-logo" link="https://www.bloombergquint.com/">
        <BQLogo />
      </LinkView>

      <LinkView className="header-fit-logo opacity-logo" link="https://fit.thequint.com/">
        <FitLogo />
      </LinkView>
    </React.Fragment>
  );

  // Logs for Quint-Hindi
  const getHindiLogoView = () => (
    <React.Fragment>
      <div styleName="vertical-line"></div>

      <LinkView className="english-quint-desktop-view" link="https://www.thequint.com/">
        <TheQuintLogo width={75} height={42} color="#fff" />
      </LinkView>

      <LinkView className="header-bq-logo bq-logo" link="https://www.bloombergquint.com/">
        <BQLogo />
      </LinkView>

      <LinkView className="header-fit-logo opacity-logo" link="https://fit.thequint.com/">
        <FitLogo />
      </LinkView>
    </React.Fragment>
  );

  // Mobile Logo View
  const getMobileLogoView = () => {
    if (publisherName === "quint-hindi") {
      return (
        <div className="header-hq-logo" styleName="hindi-color-logo">
          <QuintHindiLogo width={130} height={46} />
        </div>
      );
    } else if (publisherName === "fit") {
      return (
        <div styleName="fit-color-logo">
          <FitColorLogo width={83} />
        </div>
      );
    }

    return (
      <div styleName="engish-quint-logo">
        <TheQuintLogo width={74} height={46} />
      </div>
    );
  };

  // Desktop Logo View
  const getDesktopLogoView = () => {
    // Quint Desktop Logo View
    if (publisherName === "quint") {
      return (
        <React.Fragment>
          <Link href="/" styleName="quint-logo">
            <TheQuintLogo width={95} height={60} />
          </Link>

          {getQuintLogoView()}
        </React.Fragment>
      );
    }

    // Hindi Quint Desktop Logo View
    if (publisherName === "quint-hindi") {
      return (
        <React.Fragment>
          <Link href="/" styleName="quint-logo">
            <HindiQuintLogo />
          </Link>

          {getHindiLogoView()}
        </React.Fragment>
      );
    }

    // Fit Desktop Logo View
    return (
      <React.Fragment>
        <Link href="/" styleName="quint-logo">
          <FitColorLogo width={100} height={60} />
        </Link>

        <div styleName="vertical-line"></div>

        <div styleName="fit-desktop-view">
          <LinkView className="header-tq-logo" link="https://www.thequint.com/">
            <TheQuintLogo width={75} height={50} color="#fff" />
          </LinkView>

          <LinkView className="header-bq-logo fit-bq-logo" link="https://www.bloombergquint.com/">
            <BQLogo />
          </LinkView>

          <LinkView className="header-hq-logo" link="https://hindi.thequint.com/">
            <QuintHindiLogo />
          </LinkView>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div styleName="header-wrapper">
      {/* Primary Header */}
      <div styleName="primary-wrapper">
        {/* Desktop - Content */}
        <div styleName="left-content">{getDesktopLogoView()}</div>

        {/* Desktop - Content */}
        <div styleName="right-content">
          {getButtonsView()}
          <Link href="/search" className="header-search-icon" styleName="search-desktop-icon">
            <SearchIcon />
          </Link>
          <ToggleTheme />
        </div>

        {/* Mobile - Content */}
        <div styleName="mobile-content">
          <div styleName="hamburger-icon" onClick={onHamburgerClick}>
            <HamburgerIcon />
          </div>
          <Link href="/" styleName="mobile-logo">
            {getMobileLogoView()}
          </Link>
          <Link href="/search" className="header-search-icon" styleName="search-mobile-icon">
            <SearchIcon />
          </Link>
        </div>
      </div>

      {/* Secondary Header */}
      <SecondaryMenu
        items={menuItems}
        pageType={pageType}
        publisherName={publisherName}
        isHomeMenuRequired={isHomeMenuRequired}
        currentHostUrl={currentHostUrl}
      />

      {/* Mobile Overlay Popup */}
      <div id="mySidenav" styleName="mobile-popup-overlay">
        <MobilePopupMenu
          items={hamburgerMenuItems}
          currentHostUrl={currentHostUrl}
          pageType={pageType}
          closeClick={onHamburgerClick}
          navigateToPage={navigateToPage}
          publisherName={publisherName}
          member={member}
          onPopupSettingsClick={onPopupSettingsClick}
          currentPath={currentPath}
          setUpUserFlow={setUpUserFlow}
        />
      </div>

      {/* Popup Modal's */}
      {loginPopupView()}
      {settingsPopupView()}
    </div>
  );
};

Header.propTypes = {
  secondaryMenuItems: array,
  hamburgerMenuItems: array,
  pageType: string,
  publisherAttributes: object,
  navigateToPage: func,
  setMember: func,
  setUserPlans: func,
  setAccessTypeLoad: func,
  member: object,
  currentPath: string,
  menuList: array,
  sectionsList: array,
  collectionItems: array,
  sectionId: number,
  currentHostUrl: string,
};

const mapStateToProps = (state) => {
  return {
    secondaryMenuItems: get(state, ["qt", "data", "navigationMenu", "secondaryMenuItems"], []),
    hamburgerMenuItems: get(state, ["qt", "data", "navigationMenu", "hamburgerMenuItems"], []),
    pageType: get(state, ["qt", "pageType"], ""),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"]),
    currentHostUrl: get(state, ["qt", "currentHostUrl"], ""),
    menuList: get(state, ["qt", "config", "layout", "menu"], []),
    sectionsList: get(state, ["qt", "config", "sections"]),
    currentPath: get(state, ["qt", "currentPath"], ""),
    collectionItems: get(state, ["qt", "data", "collection", "items"], []),
    sectionId: get(state, ["settingsReducer", "sectionId"], null),
    member: state.member,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUserPlans: (plans) => dispatch(setUserPlans(plans)),
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMember: (member) => dispatch(setMember(member)),
  setAccessTypeLoad: () => dispatch(setAccessTypeLoad()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
